import React from 'react';
import './CommonButton.css';
import { PopCheck } from '../Dialog/PopParts';

export const btnColors = {
    "orange" : "common-btn-orange",
    "blue" : "common-btn-blue",
    "green" : "common-btn-green",
    "grey" : "common-btn-grey",
    "red" : "common-btn-red"
}

export const btnSizes = {
    "default" : "common-btn-default",
    "default-wide" : "common-btn-default-wide",
    "mini" : "common-btn-mini",
    "mini2" : "common-btn-mini-2",
    "choice1" : "common-btn-choice-1",
    "choice2" : "common-btn-choice-2",
    "button" : "common-btn-popup",
    "button-multi" : "common-btn-popup-multi",
    "wide" : "common-btn-wide"
}

//icon: icona (nodo React) al posto del testo; alt è il suo nome per le tecnologie assistive
//check: per i pulsanti che si attivano e disattivano, stato (true/false) della casella prima del testo, quella dei popup;
//checkTone è il colore della spunta. Senza check il pulsante non ha la casella
const CommonButton = ({id, txt, color, size, click, enabled=true, alt, icon, check, checkTone}) => {
    let cl = "";
    if(enabled) {
        cl = "common-btn " + color + " " + size;
    } else {
        cl = "common-btn " + btnColors["grey"] + " " + size;
    }
    const hasCheck = !icon && check !== undefined;
    if(hasCheck) {
        cl += " common-btn-check";
    }

    return (
        <div className={cl} id={id} onClick={click} {...(icon ? { role: "button", "aria-label": alt } : {})}>
            {icon ? (<span className='common-btn-icon'>{icon}</span>) : (<>
                {hasCheck && <PopCheck state={check} tone={checkTone}/>}
                <span className={size == btnSizes['button-multi'] ? "common-btn-txt-multi" : "common-btn-txt"}>
                {txt}
                </span>
            </>)}
        </div>
    );
}

export default CommonButton;